import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { graphql, fetchQuery } from 'react-relay';

import UnavailableWordIcon from 'dibs-icons/exports/Unavailable';

import { FullPageWidth } from '../../components/global/FullPageWidth/FullPageWidth';
import { getHashFragment } from '../../utils/uriUtils';
import { itemStatus } from '../../pdp/pdpMessages';

import styles from './SbSharedRedirectedItem.scss';

const sbSharedRedirectedItemTitleQuery = graphql`
    query SbSharedRedirectedItemQuery($itemId: [String]!) {
        viewer {
            itemRead(itemIds: $itemId) {
                ... on Item {
                    title
                }
            }
        }
    }
`;

export const SbSharedRedirectedItem = ({ relay }) => {
    const [itemTitle, setItemTitle] = useState('');

    useEffect(() => {
        const { href } = window.location;
        const fragment = getHashFragment(href);
        const itemHash = fragment.split('=')[1];
        if (itemHash) {
            const fetchItemTitle = async () => {
                const res = await fetchQuery(relay?.environment, sbSharedRedirectedItemTitleQuery, {
                    itemId: itemHash,
                });
                setItemTitle(res?.viewer?.itemRead?.[0]?.title);
            };
            fetchItemTitle();
        } else {
            setItemTitle('');
        }
    }, [relay]);

    if (itemTitle) {
        return (
            <FullPageWidth hasBackground hasPadding className={styles.header}>
                <div className={styles.title}>{itemTitle}</div>
                <div className={styles.statusContainer}>
                    <span className={styles.itemStatus}>{itemStatus}</span>
                    <span className={styles.iconContainer}>
                        <UnavailableWordIcon className={styles.icon} />
                    </span>
                </div>
            </FullPageWidth>
        );
    }

    return null;
};

SbSharedRedirectedItem.propTypes = {
    relay: PropTypes.object,
};
